import React from 'react';
import noPermissionSvg from './assets/403-error.svg';
import styles from './NoPermission.module.scss';
import Button from 'component/atom/forms/button/Button';
import { useNavigate } from 'react-router-dom';

const NoPermission = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{ padding: 40, textAlign: 'center' }}
      className={styles['no-permission-container']}
    >
      <img src={noPermissionSvg} alt="No Permission" style={{ width: '20%' }} />{' '}
      <Button
        onClick={() => navigate('/')}
        label="Back Home"
        variant="danger"
      />
    </div>
  );
};

export default NoPermission;
